<div class="white-wrapper layout-fluid-constrained layout-align-center">
  <div class="c-col">
    <div class="formatted-text">
      <h1>Контакти</h1>
      <p>ТЕЛЕФОН: <strong>&nbsp;0700 100 76</strong></p>
      <p>МОБИЛЕН: &nbsp;<strong>0896 86 57 96</strong></p>
      <p>ЕЛ. ПОЩА : <strong>{{ 'info@minizaem.bg' }}</strong></p>
      <p><br></p>
      <p>АДРЕС</p>
      <p><strong>София 1408, ул."Балша" № 17, офис 1</strong></p>
      <p><br></p>
      <p>РАБОНО ВРЕМЕ</p>
      <p><strong>от 8.30 до 17.30 часа</strong></p>
      <p><strong>Събота и Неделя - почивни дни</strong></p></div>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2933.098339763087!2d23.30952464181598!3d42.68045918639645!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa851b78a35545%3A0xe829ced1a632933b!2sIvan%20Vazov%2C%20ul.%20%22Balsha%22%2017%2C%201408%20Sofia!5e0!3m2!1sen!2sbg!4v1720623850698!5m2!1sen!2sbg" width="515" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>

  <div class="c-col">
    <div class="formatted-text">
      <h2>Изпрати запитване</h2>

      <div class="c-form-warapper">
        <form [formGroup]="contactForm" class="form-horizontal">
          <app-form-element name="name" label="Име" type="INPUT"></app-form-element>
          <app-form-element name="email" label="E-mail" type="INPUT" id="contactEmail"></app-form-element>
          <app-form-element name="phone" label="Телефон" type="INPUT"></app-form-element>
          <app-form-element name="text" label="Текст" type="TEXTAREA"></app-form-element>
        </form>
        <button class="btn btn-orange" type="submit" (click)="submitInquiry()">
          Изпрати
        </button>

      </div>
      <div class="formatted-text layout-mt-30">
        <p>За решаване на потребителски спорове, жалби и сигнали.</p>

        <p><b>Свържете се с нас.</b></p>

        <p><b>Сайт на Платформата ОРС:</b></p>

        <p><a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=BG" target="_blank">https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=BG</a></p>
        <p><b>Сайт на Комисия за защита на потребителите:</b></p>
        <p><a href="https://kzp.bg/" target="_blank">https://kzp.bg/</a></p>
      </div>
    </div>
  </div>
</div>
